import React from 'react'
import Price from './Price'

const Pricings = () => {
  return (
    <div>
     
      <Price/>
      <hr></hr>
    </div>
  )
}

export default Pricings
